import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import Select from 'react-select';
import { change } from 'redux-form';
import { createSelector } from 'reselect';

import helpers from './helpers';
import { elementsSelector, currentElementIdSelector } from '../../../reducers/elements';
import { relationshipsSelector } from '../../../reducers/relationships';
import '../../../styles/ReactSelect.css';

const EditorSelector = createSelector(
  [
    currentElementIdSelector,
    elementsSelector,
    relationshipsSelector,
  ],
  (
    currentElementId,
    elements,
    relationships,
  ) => ({
    currentElementId,
    elements,
    relationships,
  }),
);

@connect(EditorSelector)
export default class Editor extends PureComponent {
  static propTypes = {
    containerClassName: PropTypes.string,
    containerStyle: PropTypes.object,
    currentElementId: PropTypes.string,
    dispatch: PropTypes.func,
    elements: PropTypes.object,
    // fieldIndex: PropTypes.number,
    input: PropTypes.object,
    inlineTypeOptions: PropTypes.object,
    propTypeOptions: PropTypes.object,
    providesToConsumesFrom: PropTypes.object,
    relationships: PropTypes.object,
    uid: PropTypes.string,
    wrapperClassName: PropTypes.string,
    wrapperStyle: PropTypes.object,
  };

  componentDidMount = () => {
    const {
      currentElementId,
      dispatch,
      input,
      providesToConsumesFrom,
      relationships,
      inlineTypeOptions,
      propTypeOptions,
      uid,
    } = this.props;

    const typeOptions = inlineTypeOptions || propTypeOptions;
    let selectedValues = helpers.getElementIdsfromRelationships(
        currentElementId,
        typeOptions,
        relationships,
        providesToConsumesFrom);
    const isMultiRel = typeOptions.multi_relationship;
    if (!isMultiRel) selectedValues = (selectedValues.length > 0) ? selectedValues[0] : '';

    // console.log('selectedValues: ', selectedValues, currentElementId, this.props.uid);
    // dispatch(initialize(uid, { field: selectedValues }));
    if (selectedValues.length > 0) {
      dispatch(change(uid, input.name, selectedValues));
    }
  }

  render = () => {
    const {
      containerClassName,
      containerStyle,
      currentElementId,
      elements,
      // fieldIndex,
      input,
      inlineTypeOptions,
      propTypeOptions,
      wrapperClassName,
      wrapperStyle,
    } = this.props;

    const typeOptions = inlineTypeOptions || propTypeOptions;
    const isMultiRel = (typeOptions && typeOptions.multi_relationship) ? true : false;  // eslint-disable-line
    const options = helpers.populateOptions(typeOptions, elements, currentElementId);
    // const zIndex = 500 - fieldIndex;

    // console.log('isMultiRel: ', isMultiRel, currentElementId);
    // console.log('selectedValues: ', selectedValues, 'options: ', options, 'input: ', input);

    const editor = (
      <div style={{ zIndex: 500 }}>
        <div className={wrapperClassName} style={wrapperStyle}>
          <div className={containerClassName} style={containerStyle}>
            <Select
              ref={input1 => {
                this.theInput = input1;
              }}
              multi={isMultiRel}
              simpleValue
              autoBlur
              joinValues
              clearable={false}
              searchable
              matchProp={'label'}
              matchPos={'any'}
              onBlurResetsInput={false}
              onCloseResetsInput={false}
              onBlurSelectsFocusedOption
              backspaceRemoves={false}
              cache={false}
              /* className="form-control c-select"*/
              style={{ display: 'inline-block', height: 'auto' }}
              {...input}
              options={options}
              onBlur={() => {
                this.theInput.closeMenu();
              }}
            />
          </div>
        </div>
      </div>
    );
    return editor;
  };
}



// WEBPACK FOOTER //
// ./src/components/types/RelationshipSelect/Editor.js